module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a03436c2c26c934fc0a7997065971874.png";